//Optional todo: make this multilingual

export default function nth0(n: number) {
	const nMod100 = n % 100;
	const nMod10 = n % 10;

	return (n + 1) + (
		nMod100 > 9 && nMod100 < 20 ? "th" :
		nMod10 === 0 ? "st" :
		nMod10 === 1 ? "nd" :
		nMod10 === 2 ? "rd" : "th");
}